import { Component, Input, OnInit, Output, EventEmitter} from "@angular/core";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { SpinnerService} from 'shared-components';
import { CultivosService } from '../../../../services/cultivos.service';

@Component({
    selector: 'app-cultivo-catastro',
    templateUrl: './cultivo-catastro.component.html'
})
export class CultivoCatastroComponent implements OnInit {

    public listaCultivosCatastro;

    public editables;
    public new = false;
    public newEditModal = false;
    public deleteModal = false;
    public toCloseSpinner = 0;

    private _filters;
    public _cultivoCatastro;
    public _cultivoId;

    public showError: boolean;
    public showWarning: boolean;

    public orderBy: string;
    public firtstime = true;
    public idColumn;

    @Input() set catastrosCultivo(cultivoId: any) {
        let filters = {
            cultivoId: cultivoId
        };
        this._cultivoId = cultivoId;
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._cultivosService.getCatastrosByCultivoId(filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            this.listaCultivosCatastro = resp.lista;
        });
    }
    @Input() campanyaHabilitada: boolean;

    @Output() pushMessage = new EventEmitter<string>();

    constructor(
        private readonly _spinnerService: SpinnerService,
        private readonly _cultivosService: CultivosService,
        private readonly _sessionContext: SessionContextService
    ) {}

    ngOnInit() {

    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public get claims() {
        return this._sessionContext.sessionUser.lsClaimTypes;
    }

    public close() {
        this.deleteModal = false;
        this.newEditModal = false;
    }

    public refresh(value) {
        this.editables = '';
        this.newEditModal = false;
        if (value) {
            this.reload();
        }
    }

    public reload() {
        this.new = false;
        let filters = {
            cultivoId: this._cultivoId
        };
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._cultivosService.getCatastrosByCultivoId(filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            this.listaCultivosCatastro = resp.lista;
        });
    }

    public editableChanged(cultivoCatastro) {
        this.editables = cultivoCatastro;
        this.new = false;
    }

    private checkCloseSpinner() {
        this.toCloseSpinner -= 1;
        if (this.toCloseSpinner === 0) {
            this._spinnerService.hideSpinner();
        }
    }

    public toOrderBy(id: any) {
      this.idColumn = id;
      if (this.firtstime) {
          this.orderBy = 'desc';
          this.firtstime = false;
      } else {
          if (this.orderBy === 'desc') {
              this.orderBy = 'asc';
          } else if (this.orderBy === 'asc') {
              this.orderBy = 'desc';
          }
      }
    }

    public getIcon(id: any) {
      let iconClass = 'fa fa-sort';
      if (id === this.idColumn) {
          iconClass = this.orderBy === 'desc' ? 'fa fa-sort-down' : 'fa fa-sort-up';
      }
      return iconClass;
    }
}
